<div matDialogTitle class="video-request__header">
  <h1 *ngIf="!(data.videoDeviceInfo | async).online" class="video-request__header__title" i18n="@@S_VOD_REQUEST_SENT">Request sent</h1>
  <h1 *ngIf="(data.videoDeviceInfo | async).online" class="video-request__header__title" i18n="@@S_REQUEST_VIDEO_ON_THE_WAY_TITLE">
    Your video is on the way
  </h1>
  <button mat-icon-button matDialogClose class="video-request__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="video-request__content">
  <span *ngIf="!(data.videoDeviceInfo | async).online" i18n="@@S_VOD_REQUEST_SENT_DESC">
    You will receive the video when the camera is back online. Turn the vehicle on to access the footage sooner.<br /><br />
    If you don't receive a video notification, check the camera is working properly.
    <a
      class="request-offline-link"
      tabindex="0"
      href="https://reveal-help.verizonconnect.com/hc/en-us/articles/4408163295251"
      target="_blank"
      rel="noopener"
      >Learn more.</a
    >
  </span>
  <span *ngIf="(data.videoDeviceInfo | async).online" i18n="@@S_REQUEST_VIDEO_ON_THE_WAY_MESSAGE">
    This might take a few minutes. We'll notify you when the video is available.
  </span>
</div>

<div matDialogActions class="video-request__actions">
  <button
    mat-button
    *ngIf="!data.returnBackToVideo"
    class="btn-uppercase vzc-small"
    componentStyle="tertiary"
    i18n="@@S_VOD_BACK_TO_REPLAY"
    (click)="closeModal(true)"
  >
    BACK TO REPLAY
  </button>
  <button
    mat-button
    *ngIf="data.returnBackToVideo"
    class="btn-uppercase vzc-small"
    componentStyle="tertiary"
    i18n="@@S_VOD_BACK_TO_EVENTS"
    (click)="openVideoEventsPage()"
  >
    BACK TO EVENTS TAB
  </button>
  <button
    mat-flat-button
    class="btn-uppercase vzc-small"
    color="accent"
    componentStyle="primary"
    i18n="@@S_VOD_REQUEST_ANOTHER_VIDEO"
    (click)="closeModal(false)"
  >
    REQUEST ANOTHER VIDEO
  </button>
</div>
